import React, {useEffect, useRef, useState, useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import {setAccessToken} from "../slices/authSlice";
import {BaseDataGrid} from '@seismic/mantle-datagrid';
import {
    getContentUsage,
    getContentUsageDetail
} from "../api/client";
import {Header} from "../components/Header";
import '@seismic/mantle-datagrid/dist/mantle-datagrid.css'
import {HumanDuration, HumanDate} from "../components/Helpers";
import {Spinner, Button, Select, Modal, FormField, DateInput, Badge} from "@seismic/mantle";
import {CenteredSpinner2} from "../components/CenteredSpinner";

const noImageStyle = {
    border: "1px solid gray",
    width: 100,
    height:100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
}

const RelatedContent = ({related}) => {
    
    const [showDetail, setShowDetail] = useState(false)
    
    return <div>
        <div style={{display: "flex", gap: 16}} onClick={() => setShowDetail(!showDetail)}>
            <div>
                {related.smallMediumThumbnailUrl == null ? <div style={noImageStyle}>?</div> : <img src={related.smallMediumThumbnailUrl} alt={related.name} style={{width: 100}} loading="lazy"/>}
            </div>
            <div>
                <h4>{related.name} (page {related.pageIndex})</h4>
                <div style={{display: "flex", justifyContent: "space-between", paddingTop: "16px", paddingBottom: "16px"}}>
                    <div>{related.meetings.length} Meetings</div>
                    <div>{related.livesends.length} Livesends</div>
                    <div>{related.dsrs.length} DSRS</div>
                </div>
                <div>Repository: {related.repository}</div>
            </div>
        </div>
        {showDetail && <div>
            {related.meetings.length > 0 && <div>
                <h5>Meetings</h5>
                {related.meetings.map(meeting => <div key={meeting.meetingId}>
                    <li>{meeting.name} ({meeting.type}/{meeting.externalMeetingType}) - <HumanDate date={meeting.startedAt} />. Lasting <HumanDuration duration={meeting.durationSeconds * 1000} />. Hosted by <a mailTo={meeting.hostUserName}>{meeting.hostUserName}</a></li>
                </div>)}
            </div>}
            {related.livesends.length > 0 && <div>
                <h5>Livesends</h5>
                {related.livesends.map(ls => <div key={ls.occurredAt}>
                    <li><HumanDate date={ls.sessionStartedAt} />. Lasting <HumanDuration duration={ls.duration} /> {ls.livesendViewingSessionId}</li>
                </div>)}
            </div>}
            {related.dsrs.length > 0 && <div>
                <h5>DSRs</h5>
                {related.dsrs.map(dsr => <div key={dsr.occurredAt}>
                    <li><HumanDate date={dsr.sessionStartedAt} />. Lasting <HumanDuration duration={dsr.duration} /> {dsr.livesendViewingSessionId}</li>
                </div>)}
            </div>}
        </div>}
        <hr />
    </div>
}

export const ContentUsageDetail = ({setContentVersionId, contentVersionId, page, lookback, oldWay}) => {
    
    const [details, setDetails] = useState(null);

    
    useEffect(() => {
        setDetails(null);
        if(contentVersionId != null) {
            getContentUsageDetail(contentVersionId, page, lookback, oldWay).then((data) => setDetails(data)).catch((error) => console.error(error));
        }
    }, [contentVersionId, page, lookback, oldWay]);

    return <Modal
        size="xl"
        open={contentVersionId != null}
        onClose={() => setContentVersionId(null)}
        header={details == null ? "Loading..." : (details.name + " (page " + details.pageIndex + ")")}
        closeOnOutsideClick
        footerButtonProps={[
        ]}
    >
        {details == null && <CenteredSpinner2 message="Loading..." />}
        {details !== null && <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ display: 'flex', flexDirection: "column", gap: 8 }}>
                <div>
                    <a target="_blank" href={`https://quake.seismic.com/app#/contentmanager/detail/${details.teamsiteId}/${details.contentId}/info/LIST/title?versionId=${details.contentVersionId}&structureId=undefined`}>
                        {details.smallMediumThumbnailUrl == null ? <div style={noImageStyle}>?</div> : <img src={details.smallMediumThumbnailUrl} style={{ width: 200 }} alt="thumbnail" />}
                    </a>
                </div>
                <div>
                    <div>Version {details.version}</div>
                    <div>Type: {details.type}</div>
                    <div>Format: {details.format}</div>
                    <div>Total Meetings: {details.totalMeetings}</div>
                    <div>Total Livesends: {details.totalLivesends}</div>
                    <div>Total DSRs: {details.totalDsrs}</div>
                </div>
            </div>
            <div>
                {details.related.map(a=> <RelatedContent key={a.contentVersionId} related={a} />)}
            </div>
        </div>}
    </Modal>
}


export const ContentUsage = () => {
    
    const dispatch = useDispatch();
    const [contentUsage, setContentUsage] = useState(null);
    const [title, setTitle] = useState('');
    const [lookback, setLookback] = useState(90);
    const filteredContentUsage = contentUsage == null ? null : contentUsage.filter((content) => content.name.toLowerCase().includes(title.toLowerCase()));

    const [[gridApi, columnApi], setApis] = React.useState([undefined, undefined])
    const [[prevGridState, currGridState], setGridStates] = React.useState([undefined, undefined])
    const skipUpdateOnce = React.useRef(false)
    const [thumbnail, setThumbnail] = useState(null)
    const [left, setLeft] = useState(0)
    const [top, setTop] = useState(0)
    const [oldWay, setOldWay] = useState(true)
    const [contentVersionId, setContentVersionId] = useState(null)
    const [page, setPage] = useState(null);

    const signOut = () => {
        dispatch(setAccessToken(null));
    }
    
    const setThumbnailLocation = (url, e) => {
        console.log('e', e);
        setLeft(e.clientX + 50);
        setTop(e.clientY);
        setThumbnail(url)
    }
    
    const openDetails = (data) => {
        setContentVersionId(data.contentVersionId);
        setPage(data.page);
    }
    
    useEffect(() => {
        setContentUsage(null);
        getContentUsage(lookback, oldWay)
            .then((data) => setContentUsage(data))
            .catch((error) => console.error(error));
    }, [lookback, oldWay]);
    
    const ThumbnailCell = props => props.value == null ? <div>?</div> : <img onMouseOver={e=>setThumbnailLocation(props.value, e)} onMouseLeave={e=> setThumbnailLocation(null, e)} loading="lazy" src={props.value} style={{width: "100px"}} alt="thumbnail" />
    const DurationCell = props => <HumanDuration duration={props?.value} />
    const CountCell = props => props?.value?.toLocaleString() ?? '0'
    const TitleCell = props => <a target="_blank" href={`https://quake.seismic.com/app#/contentmanager/detail/${props.data.teamsiteId}/${props.data.contentId}/info/LIST/title?versionId=${props.data.contentVersionId}&structureId=undefined`}>{props.value}</a>
    const DetailCell = props => <a onClick={()=>openDetails(props.data)}>Details</a>

    const columnDefs = [
        { field: 'smallMediumThumbnailUrl', cellStyle: {textAlign:"center"}, headerName: 'Thumbnail', maxWidth: 120, initialPinned: true, cellRenderer: 'ThumbnailCell'},
        { field: 'name', headerName: 'Title', minWidth: 400, initialPinned: true, filter: true, cellRenderer: 'TitleCell' },
        { field: 'page', headerName: 'Page#', maxWidth: 80, initialPinned: true, sortable: true },
        { field: 'contentVersionId', cellStyle: {textAlign:"center"}, headerName: '', filter: false, sortable: false, maxWidth: 120, initialPinned: true, cellRenderer: 'DetailCell'},
        { field: 'allTotalSeconds', headerName: 'Total Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'allTotalCount', headerName: 'Total Count', minWidth: 115, cellRenderer: 'CountCell'},
        { field: 'avgSecondsPerViewingSession', headerName: 'Avg Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'totalLivesendSeconds', headerName: 'Total Livesend Sessions', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'totalLivesendCount', headerName: 'Livesend Sessions', minWidth: 140, cellRenderer: 'CountCell'},
        { field: 'avgSecondsPerLivesendViewingSession', headerName: 'Avg Livesend Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'totalDsrSeconds', headerName: 'DSR Session Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'totalDsrSessionCount', headerName: 'DSR Session Count', minWidth: 200, cellRenderer: 'CountCell'},
        { field: 'avgSecondsPerDsrViewingSession', headerName: 'Avg. DSR Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'totalMeetingSeconds', headerName: 'Meeting Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'totalMeetingCount', headerName: 'Meeting Count', minWidth: 200, cellRenderer: 'CountCell'},
        { field: 'avgSecondsPerMeeting', headerName: 'Avg Meeting Time', minWidth: 200, cellRenderer: 'DurationCell'},
        { field: 'recordedMeetingCount', headerName: 'Recorded Meeting Count', minWidth: 200, cellRenderer: 'CountCell'},
    ];
    
    return <>
        <ContentUsageDetail contentVersionId={contentVersionId} setContentVersionId={setContentVersionId} setPage={setPage} page={page} lookback={lookback} oldWay={oldWay} />
        <Header signOut={signOut} title="Content Usage" navigateTo="/ContentUsage" />
        <div style={{padding: "16px", height: "90vh"}}>
            {thumbnail && <div style={{position: "absolute", top: top, left: left, zIndex: 1000}}>
                <img alt="thumbnail" src={thumbnail} style={{maxWidth: "100%", maxHeight: "100%"}} onClick={()=>setThumbnail(null)} />
            </div>}
            <div style={{paddingBottom: "16px", display: "flex", alignItems: "center", gap: 8}}>
                <div>
                    Title: <input style={{width: 600}} value={title} onChange={e=>setTitle(e.target.value)} />    
                </div>
                <div>
                    <select value={lookback} onChange={e=>setLookback(e.target.value)}>
                        <option value={7}>Lookback 7 days</option>
                        <option value={14}>Lookback 14 days</option>
                        <option value={30}>Lookback 30 days</option>
                        <option value={60}>Lookback 60 days</option>
                        <option value={90}>Lookback 90 days</option>
                        <option value={180}>Lookback 180 days</option>
                        <option value={365}>Lookback 365 days</option>
                        <option value={365*100}>Lookback All Time</option>
                    </select>
                </div>
                <div>
                    Old Way <input type="checkbox" checked={oldWay} onChange={e=>setOldWay(e.target.checked)} />
                </div>
                <div>
                    <Button
                        label="Clear Column State"
                        disabled={!prevGridState}
                        onClick={() => {
                            console.log('clear column state')
                            skipUpdateOnce.current = true
                            setGridStates(prev => {
                                const [prevGridState, currGridState] = prev
                                return [undefined, prevGridState]
                            })
                            localStorage.removeItem('contentUsageColumnState');
                            columnApi.resetColumnState();
                        }}
                    />
                </div>
                {contentUsage == null && <div>
                    <Spinner />
                </div>}
            </div>
            <div style={{width: "100%", height: "100%"}}>
                <BaseDataGrid
                    itemCountTotal={contentUsage?.length ?? 0}
                    itemCountCurrent={filteredContentUsage?.length}
                    loadingMessage="Loading content usage data..."
                    rowData={filteredContentUsage}
                    gridState={currGridState}
                    onGridStateChanged={lastState => {
                        console.log('on grid state changed')
                        let columnState = JSON.stringify(columnApi.getColumnState());
                        localStorage.setItem('contentUsageColumnState', columnState);

                        // Don't update state if `Undo` button has been pressed.
                        if (skipUpdateOnce.current) {
                            console.log('skipUpdateOnce.current')
                            skipUpdateOnce.current = false
                            return
                        }
                        setGridStates(prevGridStates => {
                            const [_prevGridState, _currGridState] = prevGridStates
                            console.log('setGridStates', _prevGridState, _currGridState, lastState)
                            return [_currGridState, lastState]
                        })
                    }}
                    onGridReady={e => {
                        console.log('onGridReady', prevGridState)
                        setApis([e.api, e.columnApi])
                        if(!prevGridState) {
                            e.columnApi.autoSizeAllColumns();
                        }
                    }}
                    onFirstDataRendered={e => {
                        console.log('onFirstDataRendered')
                        const columnState = JSON.parse(localStorage.getItem('contentUsageColumnState'));
                        if(columnState) {
                            console.log('applyColumnState', columnState)
                            e.columnApi.applyColumnState({state: columnState, applyOrder: true});
                        }
                    }}
                    frameworkComponents={{
                        ThumbnailCell: ThumbnailCell,
                        TitleCell: TitleCell,
                        DurationCell: DurationCell,
                        CountCell: CountCell,
                        DetailCell: DetailCell
                    }}
                    columnDefs={columnDefs}
                    suppressClickEdit={true}
                />
            </div>
        </div>
    </>;
}